import { Component, OnInit } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { UserProfileService } from "../../../services/user-profile.service";
import { Subscription } from "rxjs";
import { AutoUnsubscribe } from "../../../constant/unsubscriber";
import {
  Router,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  NavigationStart,
} from "@angular/router";
import { PROPERTY_BOOKING, LOYALTY_REWARDS, DELETE_ACCOUNT } from "src/app/constant/routes";
import { UtilityService } from "src/app/services/utility.service";
import { FAQ_URL, TERMS_OF_USE, PRIVACY } from "src/app/constant/app-constant";
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ApplyCouponComponent } from '../../features/apply-coupon/apply-coupon.component';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
// @AutoUnsubscribe()
export class FooterComponent implements OnInit {
  // hostPanelUrl = environment.hostPanelUrl;
  subscription = new Subscription();
  profileDetail: any = null;
  showFooter = true;
  userData: any;

  constructor(
    private userProfileService: UserProfileService,
    private router: Router,
    private utilityService: UtilityService,
    private _bottomSheet: MatBottomSheet,
    private userProfile: UserProfileService
  ) {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        const currenUrl = this.router.url.split("?")[0];
        this.showFooter = !(currenUrl.indexOf(PROPERTY_BOOKING.fullUrl) > -1);
      } else if (event instanceof NavigationError) {
        const currenUrl = this.router.url.split("?")[0];
        this.showFooter = !(currenUrl.indexOf(PROPERTY_BOOKING.fullUrl) > -1);
      } else if (event instanceof NavigationCancel) {
        const currenUrl = this.router.url.split("?")[0];
        this.showFooter = !(currenUrl.indexOf(PROPERTY_BOOKING.fullUrl) > -1);
      }
    });
  }

  redirectToFaq() {
    window.open(FAQ_URL, "_blank");
  }

  redirectToTerms() {
    window.open('terms', "_blank");
  }

  redirectToPrivacy() {
    window.open('privacy', "_blank");
  }

  redirectToDeleteAccount(){
    this.router.navigate([DELETE_ACCOUNT.fullUrl]);
  }

  async openCouponPanel() {
    this.userData = await this.userProfile.getProfileDetail();
    if (this.userData) {
      const applyOfferSheetRef = this._bottomSheet.open(ApplyCouponComponent, {
        closeOnNavigation: true,
        panelClass: "bottom-sheet",
        data: {hideApply: true, headerMessage: 'Promo Codes' },
      });
    } else {
      this.utilityService.openDialog({message: 'We have best exciting offers for you, please login to enjoy !', hideCancelButton: true, confirmButtonText: 'Ok'})
    }
  }

  async openLoyaltyPanel() {
    this.userData = await this.userProfile.getProfileDetail();
    if (this.userData) {
      this.router.navigate([LOYALTY_REWARDS.fullUrl])
    } else {
      this.utilityService.openDialog({message: 'Use your Wallet Rewards and get your food at minimum cost. Login to see how much points you got !', hideCancelButton: true, confirmButtonText: 'Ok'})
    }
  }

  profileListener() {
    this.userProfileService.profileDetail.subscribe((data) => {
      if (data) {
        this.profileDetail = data;
      }
    });
  }

  ngOnInit(): void {
    this.subscription.add(
      this.userProfileService.profileDetail.subscribe((data) => {
        this.profileDetail = data;
      })
    );
  }
}
